var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { Mesh } from 'three';
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader';
export class MaterialLoader {
    constructor() {
        this.cache = new Map();
        this.loader = new GLTFLoader();
        const dracoLoader = new DRACOLoader();
        dracoLoader.setDecoderPath('./three/draco/gltf/');
        this.loader.setDRACOLoader(dracoLoader);
    }
    get(materialSpecification_1) {
        return __awaiter(this, arguments, void 0, function* (materialSpecification, onProgress = () => { }) {
            const path = materialSpecification.fileName;
            if (this.cache.has(path)) {
                const file = this.cache.get(path);
                const mesh = getMeshByName(file, materialSpecification.meshName);
                return Promise.resolve(mesh ? mesh.material : undefined);
            }
            return new Promise((resolve, reject) => {
                this.loader.load(path, (gltf) => {
                    this.cache.set(path, gltf.scene);
                    const mesh = getMeshByName(gltf.scene, materialSpecification.meshName);
                    resolve(mesh ? mesh.material : undefined);
                }, onProgress, reject);
            });
        });
    }
}
function getMeshByName(model, name) {
    const mesh = model.getObjectByName(name);
    if (!(mesh instanceof Mesh)) {
        return undefined;
    }
    return mesh;
}
//# sourceMappingURL=MaterialLoader.js.map